exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customize_page_management[data-v-78aca090]{padding:0 20px}.card[data-v-78aca090]{width:100%;border-bottom:1px solid #e0e0e0;padding:20px 20px 15px 20px;font-weight:bold;color:#222}.add_btn[data-v-78aca090]{background:#4d8aff;border-radius:4px;padding:2px 10px;font-size:18px;color:#fff;margin-bottom:4px;margin-right:20px}.search_criteria[data-v-78aca090]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:10px 0}.search_criteria>div[data-v-78aca090]{margin:6px 5px;width:180px;border:1px solid #efefef}.tips[data-v-78aca090]{background:#fdf6ec;color:#f59a23;padding:10px 5px}", ""]);

// exports
